import type { MaybeRef } from 'vue';

export const canvasQueryKey = 'canvas';
export const getCanvasQueryKey = (url: MaybeRef<string | undefined>) => [
  canvasQueryKey,
  'get-canvas',
  url,
];
